<template>
  <div class="base-timer" style="text-align:center">
    <v-progress-circular
      :rotate="270"
      :size="150"
      :width="15"
      :value="myPersenTimeLeft"
      color="pink"
    >
      <span class="title">{{ myFormattedTimeLeft }}</span>
    </v-progress-circular>   
  </div>
</template>

<script>
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

const TIME_LIMIT = 60;

export default {
  props:{
    eventEnd: {
      type: Number,
      //default: 1600444800
    }
  },
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      persen : 100,
      totalTime : 0,
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${minutes}:${seconds}`;
    },

    myFormattedTimeLeft(){
      var diffTime = this.timeLeft*1000;
      diffTime = diffTime >= 0 ? diffTime : 0;
      var duration = this.$moment.duration(diffTime, 'milliseconds');
      return duration.hours() + ":" + duration.minutes() + ":" + duration.seconds();
    },

    myPersenTimeLeft(){      
      var persen   = this.timeLeft/this.totalTime *100;      
      return persen;
    },

    timeLeft() {      
      var time_limit = this.eventEnd - (this.$moment()/1000)      
      return time_limit - this.timePassed;
      //return TIME_LIMIT - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / TIME_LIMIT;
      return rawTimeFraction - (1 / TIME_LIMIT) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    }
  },
  created(){        
    this.totalTime = this.eventEnd - (this.$moment().valueOf() / 1000);    
  },
  watch: {
    timeLeft(newValue) {
      if (newValue <= 0) {        
        this.onTimesUp();
      }
    },
    eventEnd(){
      this.totalTime = this.eventEnd - (this.$moment().valueOf() / 1000);
    }
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
      this.$emit('finish', true);
    },

    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    }
  }
};
</script>

